import { gql, useQuery } from '@apollo/client';

import {
  useNextGroupPriority_GetNextPriority,
  useNextGroupPriority_GetNextPriorityVariables,
} from './graphql-types/useNextGroupPriority_GetNextPriority';

const GET_NEXT_PRIORITY = gql`
  query useNextGroupPriority_GetNextPriority(
    $input: NextAvailableGroupPriorityInput!
  ) {
    nextAvailableGroupPriority(input: $input) {
      nextPriority
    }
  }
`;

export const useNextGroupPriority = (options: {
  parentGroupId?: string;
}): { loading: boolean; nextGroupPriority: number } => {
  const { parentGroupId } = options;
  const { data: nextPriority, loading } = useQuery<
    useNextGroupPriority_GetNextPriority,
    useNextGroupPriority_GetNextPriorityVariables
  >(GET_NEXT_PRIORITY, {
    variables: { input: { data: { parentGroupId: parentGroupId ?? null } } },
  });

  return {
    loading: loading,
    nextGroupPriority:
      nextPriority?.nextAvailableGroupPriority.nextPriority ?? 0,
  };
};
